import { render, staticRenderFns } from "./ListTIDAndMid.vue?vue&type=template&id=e97f4648&"
import script from "./ListTIDAndMid.vue?vue&type=script&lang=js&"
export * from "./ListTIDAndMid.vue?vue&type=script&lang=js&"
import style0 from "./ListTIDAndMid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports